/* Booking all items popup */
angular.module('cfn').controller('allItemsPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  'i18nFilter',
  function($scope, $rootScope, $http, i18nFilter) {
    // This is called when the popover is shown.
    var onShow = angular.bind(this, function() {
      this.getAllItems();
    });

    $scope.goBackToCore = function(content) {
      $scope.$emit('goToCore', '/core/index');
    };

    // Required to have all generic popover methods.
    addListPopupCode(this, $scope, null, onShow, null);

    // Loads all activated items.
    this.getAllItems = function() {
      var url = '/365FarmNet/rest/core/stockyard/getArticles';
      this.listData = null;

      app.startLoading();

      $http.get(url).then(
        angular.bind(this, function(response) {
          app.finishLoading();
          this.listData = this.transformData(response.data.list);
        })
      );
    };

    // The result from the server contains an array for each item type,
    // so the arrays have to be merged for the directive.
    this.transformData = function(data) {
      var transformedData = [];

      angular.forEach(data, function(value, key) {
        angular.forEach(data[key], function(v, k) {
          v._objectType = v.type.toLowerCase();
        });

        transformedData = transformedData.concat(data[key]);
      });
      //console.log('transformedData: ', transformedData);
      return transformedData;
    };

    return ($scope.allItemsPopupController = this);
  }
]);
